import{useRef}from"react";var useIsFirstRender=function(){var a=useRef(!0);return a.current?(a.current=!1,!0):a.current};export default useIsFirstRender;